import React from 'react';
import _ from 'lodash';

import {
  AppSettingsActivity_RolesTabDocument,
  PermissionGroupName,
  PermissionName,
  useAppSettingsActivity_RolesTabQuery,
  useDeleteUserRoleTemplateMutation,
  useSaveUserRoleTemplateMutation,
  VisibilityScopeName
} from 'generated/graphql';

import * as types from './types';



export interface IPermissionGroup {
  name: PermissionGroupName;
  displayName: string;
  permissions: IPermission[];
}

export interface IPermission {
  name: PermissionName;
  displayName: string;
}

export interface IPermissionGroup {
  name: PermissionGroupName;
  displayName: string;
}

export interface IRole {
  id: string;
  displayName: string;
  description: string;
  permissions: IPermission[];
  visibilityScopeName: VisibilityScopeName;
  visibilityScopeDisplayName: string;
}

export interface IData {
  groups: IPermissionGroup[];
  roles: IRole[];
}

export function useQuery() {
  const tuple = useAppSettingsActivity_RolesTabQuery({});

  return React.useMemo(
    () => {
      const data: IData = {
        groups: _.map(tuple.data?.permissionGroups, (group): IPermissionGroup => ({
          name: group.name,
          displayName: group.displayName,
          permissions: _.map(group.permissions, (perm): IPermission => ({
            name: perm.name,
            displayName: perm.displayName
          }))
        })),
        roles: _.map(tuple.data?.userRoleTemplates.nodes ?? [], (role): IRole => ({
          id: role.id,
          description: role.description,
          displayName: role.displayName,
          visibilityScopeName: role.visibilityScope.name,
          visibilityScopeDisplayName: role.visibilityScope.displayName,
          permissions: _.map(role.permissions, (perm): IPermission => ({
            name: perm.name,
            displayName: perm.displayName
          }))
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}


export function useSaveUserRoleTemplate() {
  const [fnMutate, tuple] = useSaveUserRoleTemplateMutation({
    awaitRefetchQueries: true,
    refetchQueries: [
      {
        query: AppSettingsActivity_RolesTabDocument,
        variables: {}
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    (formState?: types.IFormState, roleId?: string, permissions?: PermissionName[]) => {
      fnMutate({
        variables: {
          input: {
            id: roleId,
            displayName: formState?.displayName,
            description: formState?.description,
            visibilityScopeName: formState?.visibilityScopeName,
            permissions
          }
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}



export function useDeleteUseRoleTemplate() {
  const [fnMutate, tuple] = useDeleteUserRoleTemplateMutation({
    refetchQueries: [
      {
        query: AppSettingsActivity_RolesTabDocument,
        variables: {}
      }
    ]
  });

  const fnWrappedMutate = React.useCallback(
    async (id: string) => {
      await fnMutate({
        variables: {
          id
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
